import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { FormioModule } from '@formio/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { delay, map, Observable, of, ReplaySubject, Subscription, switchMap, tap } from 'rxjs';
import { DataTemplate } from '../models/data-template.model';
import { InputForm } from '../models/input-form.model';
import { OfferService } from '../services/offer.service';
import { IForm } from '../shared/formio/IForm.types';
import { FormIoBuilder } from '../shared/formio/classes/FormIoBuilder';
import { FormioPipelineUtils } from '../shared/formio/formio-pipeline-utils';
import { LoadingComponent } from '../shared/spinner/loading/loading.component';

@Component({
  selector: 'app-template-input-modal',
  templateUrl: './template-input-modal.component.html',
  styleUrls: ['./template-input-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, FormioModule, LoadingComponent]
})
export class TemplateInputModalComponent implements OnInit, OnDestroy {
  dataTemplate!: DataTemplate;
  formData: any;
  inputForm: any;
  quoteId!: string;

  options: any = FormioPipelineUtils.getFormioOptions();
  submission: any;
  form$!: Observable<any>;

  submitSubscription!: Subscription;
  quoteIdSubject = new ReplaySubject<string>(1);
  private readonly router = inject(Router);
  public activeModal = inject(NgbActiveModal);
  private readonly offerService = inject(OfferService);
  private readonly destroyRef = inject(DestroyRef);
  formLoaded = false;

  ngOnInit(): void {
    const { templateDriveId } = this.dataTemplate;

    if (!templateDriveId) {
      this.router.navigate(['/landing']);
      return this.dismissModal();
    }

    if (!this.quoteId || !this.inputForm) {
      this.form$ = this.offerService.getFormInput(templateDriveId);

      // for improve performance Start the cloning in background at beginning of the process
      this.offerService.cloneTemplate(this.dataTemplate).pipe(takeUntilDestroyed(this.destroyRef), map((res) => res.quoteId), delay(5000)).subscribe(quoteId => this.quoteIdSubject.next(quoteId!));
    } else {
      this.form$ = of(this.inputForm);
      this.quoteIdSubject.next(this.quoteId)
    }



    this.form$ = this.form$.pipe(
      tap(
        (inputData) =>
        (this.submission = FormioPipelineUtils.parseValueData(
          inputData,
          this.formData
        ))
      ),
      map((inputData: InputForm[]) => this.getFieldForm(inputData))
    );
  }

  getFieldForm(fields: any[], options?: any): any {
    const form: IForm = {
      title: options?.title,
      fields,
      buttons: [
        {
          label: 'Procedi',
          action: 'submit',
          customClass: 'mt-4 justify-content-center d-flex',
          disableOnInvalid: true,
          width: 12,
        },
      ],
    };

    return new FormIoBuilder(form);
  }

  async matricSubmitted(value: any) {
    const elements = FormioPipelineUtils.cleanSubmissionData(value);

    this.submitSubscription = this.quoteIdSubject
      .pipe(
        switchMap((quoteId) =>
          this.offerService
            .processOutput({
              templateDriveId: quoteId,
              executionTime: this.dataTemplate.executionTime,
              elements,
            })
            .pipe(tap(() => this.activeModal.close(quoteId)))
        )
      )
      .subscribe();
  }

  dismissModal() {
    this.activeModal.close();
  }
  ngOnDestroy(): void {
    this.submitSubscription?.unsubscribe();
    this.quoteIdSubject.complete();
  }
}
